module.exports = __webpack_public_path__ + "img/th_th.fcabc5dc.png";